<template>
  <div class="header-navigation-mobile">
    <keep-alive>
      <sportmaster-user-info v-if="getProcessName === 'sportmaster'" :current-user="currentUser" />
    </keep-alive>

    <router-link to="/vacancies">
      <span>{{ $tr('vacancies.title') }}</span>
    </router-link>

    <router-link to="/invitations">
      <span>{{ $tr('invites.title') }}</span>
    </router-link>

    <router-link to="/responses">
      <span>{{ $tr('responses.title') }}</span>
    </router-link>

    <router-link to="/analytics">
      <span>{{ $tr('analytics.title') }}</span>
    </router-link>

    <div class="header-navigation-mobile__line"></div>

    <rates-info />

    <div class="header-navigation-mobile__line"></div>

    <router-link to="/profile">
      <i class="icon-profile"></i>
      <span>{{ $tr('profile.title') }}</span>
    </router-link>

    <router-link v-if="isCompanyAdmin" to="/settings/company">
      <i class="icon-settings"></i>
      <span>{{ $tr('profile.group.settingsTitle') }}</span>
    </router-link>

    <!-- <vbutton
      v-if="isCompanyAdmin"
      class="header-navigation-mobile__button"
      label="rates.chooseTariff"
      @click="$router.push({ name: 'billing-tariffs' })"
      /> -->

    <router-link to="/logout" class="header-navigation-mobile__signout" @click.prevent="logout">
      <i class="icon-signout"></i>
      <span>{{ $tr('login.logout') }}</span>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import RatesInfo from './RatesInfo.vue';

// process
import SportmasterUserInfo from '@/process/sportmaster/components/header/SportmasterUserInfo';

export default {
  name: 'HeaderNavigationMobile',

  components: {
    SportmasterUserInfo,
    RatesInfo
  },

  computed: {
    ...mapGetters('process', ['getProcessName']),

    ...mapGetters('user', { currentUser: 'current', isCompanyAdmin: 'isCompanyAdmin' })
  },

  methods: {
    logout() {
      if (window.localStorage.admin_token) {
        window.localStorage.removeItem('admin_token');
      }

      this.$router.push({ path: '/logout' });
    }
  }
};
</script>

<style lang="scss">
@import '@/styles/fonts.scss';

.header-navigation-mobile {
  box-shadow: $box-shadow;
  display: flex;
  align-self: center;
  justify-content: flex-start;
  list-style: none;
  padding: 30px 30px 30px;
  position: absolute;
  right: 0;
  top: 65px;
  background: #fff;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 380px;

  a {
    display: flex;
    text-align: center;
    align-items: center;
    position: relative;
    padding: 10px;

    span {
      @include mixin-text-main;
      font-size: 20px;
      display: block;
      white-space: nowrap;
      line-height: 1.5;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: $green-hover;
        transition: color 0.3s;
      }

      &.active {
        color: $green-active;
        transition: color 0.3s;
      }
    }

    i {
      color: $main-dark;
      padding-right: 10px;
      font-size: 18px;
      transition: color 0.3s;
    }

    i:hover + span {
      color: $green-hover !important;
    }

    &:hover {
      i {
        color: $green-hover;
        transition: color 0.3s;
      }
    }

    &.active,
    &.router-link-exact-active,
    &.router-link-active {
      i,
      span {
        color: $green !important;
      }
    }
  }

  li {
    &.active,
    &.router-link-exact-active {
      i,
      span {
        color: $green !important;
      }
    }
  }

  &__line {
    margin: 10px auto;
    width: 70%;
    height: 1px;
    background: $grey-light;
  }

  &__button {
    margin: 20px auto;
  }

  &__signout {
    color: $grey !important;

    i,
    span {
      color: $grey !important;
    }

    &:hover {
      i,
      span {
        color: $green-hover !important;
        transition: color 0.3s;
      }
    }
  }
}
</style>
